module.exports = __webpack_public_path__ + "static/media/shop_30_2.4432aaeb.png";